/* oldpassion — Variant Guard
 * Sperrt Options-Werte, wenn fuer die volle aktuelle Kombination KEINE Variante existiert,
 * und zeigt bei Tap/Klick einen kurzen Hinweis (z.B. "silver gibt es nur mit creme").
 * Echte, aber ausverkaufte Varianten (Kombination existiert) bleiben klickbar -> "Benachrichtige mich" bleibt intakt.
 * Additiv, greift nur wenn eine data-op-variant-matrix im <variant-picker> steht (nur Haupt-PDP).
 */
(function () {
  function parseMatrix(picker) {
    var el = picker.querySelector('script[type="application/json"][data-op-variant-matrix]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function escId(id) {
    return (window.CSS && CSS.escape) ? CSS.escape(id) : id.replace(/([^a-zA-Z0-9_-])/g, '\\$1');
  }
  function labelFor(input) {
    return document.querySelector('label[for="' + escId(input.id) + '"]') || input.closest('label');
  }
  function currentSelection(picker) {
    var sel = {};
    picker.querySelectorAll('input[type=radio][data-option-position]').forEach(function (i) {
      if (i.checked) sel[i.getAttribute('data-option-position')] = i.getAttribute('data-value-name');
    });
    return sel;
  }
  // matrix.combos are arrays aligned to matrix.positions order; cand is a {position: value} map
  function comboExists(matrix, cand) {
    return matrix.combos.some(function (combo) {
      return matrix.positions.every(function (p, idx) { return String(combo[idx]) === String(cand[p]); });
    });
  }
  function update(picker, matrix) {
    var sel = currentSelection(picker);
    var posSet = matrix.positions.map(String);
    picker.querySelectorAll('input[type=radio][data-option-position]').forEach(function (i) {
      var pos = i.getAttribute('data-option-position');
      if (posSet.indexOf(String(pos)) === -1) return; // Option gehoert nicht zur Matrix (z.B. Combined-Listing-Link)
      var cand = Object.assign({}, sel);
      cand[pos] = i.getAttribute('data-value-name');
      var exists = comboExists(matrix, cand);
      var lbl = labelFor(i);
      if (!exists) {
        i.setAttribute('data-op-nx', '');
        if (lbl) { lbl.setAttribute('data-op-nx', ''); lbl.setAttribute('aria-disabled', 'true'); }
      } else {
        i.removeAttribute('data-op-nx');
        if (lbl) { lbl.removeAttribute('data-op-nx'); lbl.removeAttribute('aria-disabled'); }
      }
    });
  }

  // ---- Hinweis ("silver gibt es nur mit creme") ----
  function hintMessage(matrix, pos, value) {
    var generic = 'Diese Kombination gibt es nicht';
    if (matrix.positions.length !== 2) return generic;
    var idx = matrix.positions.map(String).indexOf(String(pos));
    if (idx === -1) return generic;
    var otherIdx = idx === 0 ? 1 : 0;
    var partners = [];
    matrix.combos.forEach(function (combo) {
      if (String(combo[idx]) === String(value) && partners.indexOf(combo[otherIdx]) === -1) {
        partners.push(combo[otherIdx]);
      }
    });
    if (!partners.length) return generic;
    return value + ' gibt es nur mit ' + partners.join(' oder ');
  }
  function hideHints(picker) {
    picker.querySelectorAll('.op-nx-hint').forEach(function (h) { h.remove(); });
  }
  function showHint(picker, input) {
    var matrix = picker.__opMatrix;
    if (!matrix) return;
    var fs = input.closest('.variant-picker__option') || input.closest('fieldset');
    if (!fs) return;
    // In die Swatch-Zeile rechts neben die Kreise haengen -> kein vertikaler Layout-Shift.
    var row = fs.querySelector('.variant-picker__option-values') || fs;
    hideHints(picker);
    var hint = document.createElement('span');
    hint.className = 'op-nx-hint';
    hint.setAttribute('role', 'status');
    hint.textContent = hintMessage(matrix, input.getAttribute('data-option-position'), input.getAttribute('data-value-name'));
    row.appendChild(hint);
    requestAnimationFrame(function () { hint.classList.add('is-visible'); });
    clearTimeout(picker.__hintT);
    picker.__hintT = setTimeout(function () { hideHints(picker); }, 4000);
  }

  function init(picker) {
    if (picker.__opGuard) return;
    var matrix = parseMatrix(picker);
    if (!matrix || !matrix.positions || matrix.positions.length < 2 || !matrix.combos || !matrix.combos.length) return;
    picker.__opGuard = true;
    picker.__opMatrix = matrix;
    picker.addEventListener('change', function () {
      hideHints(picker);
      setTimeout(function () { update(picker, matrix); }, 0);
    }, true);
    try {
      var mo = new MutationObserver(function () { update(picker, matrix); });
      mo.observe(picker, { childList: true, subtree: true });
    } catch (e) {}
    update(picker, matrix);
  }

  // Ein globaler Capture-Click-Blocker: Klick auf nicht-existente Kombi wird verschluckt,
  // bevor Theme-Handler feuern -> kein Variantensprung, kein Change-Event; stattdessen Hinweis.
  if (!window.__opVariantGuardClick) {
    window.__opVariantGuardClick = true;
    if (!document.getElementById('op-variant-guard-style')) {
      var st = document.createElement('style');
      st.id = 'op-variant-guard-style';
      st.textContent =
        'variant-picker [data-op-nx]{cursor:not-allowed;}' +
        '.op-nx-hint{flex:1 1 auto;min-width:0;align-self:center;margin:0;font-size:.8rem;line-height:1.3;color:inherit;' +
        'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:0;transition:opacity .18s ease;}' +
        '.op-nx-hint.is-visible{opacity:.7;}';
      (document.head || document.documentElement).appendChild(st);
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var picker = t.closest('variant-picker');
      if (!picker || !picker.__opMatrix) return;
      // clicked option input ermitteln (Label oder Input)
      var input = (t.matches && t.matches('input[data-option-position]')) ? t : null;
      if (!input) {
        var lbl = t.closest('label[for]');
        if (lbl) input = document.getElementById(lbl.getAttribute('for'));
      }
      if (!input || !input.getAttribute('data-option-position')) return;
      var matrix = picker.__opMatrix;
      var pos = input.getAttribute('data-option-position');
      if (matrix.positions.map(String).indexOf(String(pos)) === -1) return; // keine Matrix-Option
      // LIVE pruefen (unabhaengig vom async Markierungs-Update): existiert die Kombi?
      var cand = currentSelection(picker);
      cand[pos] = input.getAttribute('data-value-name');
      if (!comboExists(matrix, cand)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showHint(picker, input);
      }
    }, true);
  }

  function scan(root) {
    (root || document).querySelectorAll('variant-picker').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
